
import Button from "components/Button/index";
import upArrow from "assets/images/organisationProfile/setup/select arrow.svg";
import upArrowdark from "assets/images/organisationProfile/setup/selectArowdark.svg";
import React, { useRef, useState, useEffect } from "react";
import "./editTeamRoles.scss";
import useTheme from "hooks/observer";
import SquareCheckBox from "components/SquareCheckBox/index";
import { Role as IzRole } from "@induz/sdk";

const EditTeamRoles = ({ team, updateOperations, handleCancel }) => {
  const theme = useTheme();
  const arrow = theme === "light" ? upArrow : upArrowdark;

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedOperations, setSelectedOperations] = useState(
    team?.operations || []
  );
  const [dropdownData, setDropdownData] = useState([]);
  const [checkedStates, setCheckedStates] = useState([]);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchRolesFromWasm = async () => {
          try {
            const roleNames = await IzRole.listRoleNames(); 
            // Sort case-sensitively to help differentiate between similar names
            const sortedRoleNames = [...roleNames].sort((a, b) => a.localeCompare(b, undefined, { sensitivity: "case" }));
            const roles = sortedRoleNames.map((n) => ({ role: n }));
    
    setDropdownData(roles);
    setCheckedStates(
      roles.map((item) => team?.operations.includes(item.role))
    );
     } catch (error) {
        console.error("Error loading roles from WASM:", error);
      }
    };

    fetchRolesFromWasm();
  }, [team?.operations]);

  //  Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    if (isDropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen]);

  const handleCheckboxChange = (index) => {
    const newCheckedStates = [...checkedStates];
    newCheckedStates[index] = !newCheckedStates[index];
    setCheckedStates(newCheckedStates);

    const updatedSelectedOperations = dropdownData
      .filter((_, i) => newCheckedStates[i])
      .map((item) => item.role);

    setSelectedOperations(updatedSelectedOperations);
    updateOperations(updatedSelectedOperations); //  Sync to parent
  };

  const truncateRole = (role) => {
    if (!role) return "";
    const parts = role.split(" ");
    if (parts.length > 1) {
      return `${parts[0]} ${parts[1].charAt(0)}...`;
    }
    return role.length > 8 ? `${role.substring(0, 8)}...` : role;
  };

  const filteredDropdownData = dropdownData.filter((item) =>
    item.role.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const renderSelectedOperations = () => (
  <div className="eroSelectedRolesContainer">
    <div className="eroRoleChips">
      {selectedOperations.length > 0 ? (
        selectedOperations.slice(0, 2).map((role, index) => (
          <span key={index} className="ero-role-chip">
            {truncateRole(role)}
          </span>
        ))
      ) : (
        <span className="eroNoRoles">No operations in team</span>
      )}
      {selectedOperations.length > 2 && (
        <span className="eroRemainingCount">
          +{selectedOperations.length - 2}
        </span>
      )}
    </div>

    {isDropdownOpen && (
      <input
        type="text"
        placeholder="Search operations"
        className="eroRoleInput"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        autoFocus
      />
    )}

    <img
      src={arrow}
      alt="arrow"
      className="eroDropdownArrow"
      onClick={() => setIsDropdownOpen(true)}
    />
  </div>
);

  return (
    <div className="EditTeamRoles">
      <div className="EditTeamRolesWrapper">
        <div className="EditTeamRoleswrapperContent" ref={dropdownRef}>
          <p>Edit Roles</p>
          <div
            className="EditTeamRolesselectRole"
            onClick={() => {
              if (!isDropdownOpen) {
                setIsDropdownOpen(true);
                setSearchTerm("");
              }
            }}
          >
            <div className="eroRole">{renderSelectedOperations()}</div>
            {isDropdownOpen && (
              <div className="eroRoleDropdown">
                <ul>
                  {filteredDropdownData.map((option, index) => (
                    <li
                      key={option.role}
                      className="eroNotificationItem"
                      onClick={() => handleCheckboxChange(index)}
                    >
                      <SquareCheckBox
                        labelStyles={{
                          color: "var(--text-grey-strong)",
                          fontFamily: "Helvetica, sans-serif"
                        }}
                        isChecked={checkedStates[index]}
                        handleCheck={() => handleCheckboxChange(index)}
                      />
                      <div className="eroContent">
                        <p>{option.role}</p>
                      </div>
                    </li>
                  ))}
                </ul>
                <div className="eroRoleDropdownButtons">
                  <Button
                    type="white"
                    title="Clear"
                    width={"50%"}
                    onClick={() => {
                      setCheckedStates(Array(dropdownData.length).fill(false));
                      setSelectedOperations([]);
                      updateOperations([]);
                      setSearchTerm("");
                    }}
                  />
                  <Button
                    type="violet"
                    title="Select"
                    width={"50%"}
                    onClick={() => {
                      setIsDropdownOpen(false);
                      updateOperations(selectedOperations);
                    }}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditTeamRoles;